import { InstagramLogo, WhatsappLogo, Heart } from "@phosphor-icons/react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="bg-black py-16 px-6 border-t border-white/5"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-12">
          {/* Logo & Brand */}
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_df8219ec-752a-49fc-a15a-f7f7322a223f/artifacts/83bo8qv3_image.png" 
              alt="Tomicharte Logo" 
              className="w-16 h-16 rounded-full"
            />
            <div>
              <h3 className="font-outfit text-2xl font-bold text-white">
                Tomicharte
              </h3>
              <p className="text-[#A0AEC0] text-sm">
                Artesanato em MDF
              </p>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/5527981761251"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-[#25D366]/10 flex items-center justify-center text-[#25D366] hover:bg-[#25D366] hover:text-white transition-all"
              data-testid="footer-whatsapp"
              aria-label="WhatsApp"
            >
              <WhatsappLogo weight="fill" size={24} />
            </a>
            <a
              href="https://instagram.com/tomicharte"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-[#E1306C]/10 flex items-center justify-center text-[#E1306C] hover:bg-[#E1306C] hover:text-white transition-all"
              data-testid="footer-instagram"
              aria-label="Instagram"
            >
              <InstagramLogo weight="fill" size={24} />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/10 mb-8"></div>

        {/* Bottom */}
        <div className="flex flex-col items-center gap-4 text-sm text-[#A0AEC0] mt-8 text-center md:text-left">
          <div className="flex flex-col md:flex-row items-center justify-between w-full gap-4">
            <p>
              © {currentYear} Tomicharte. Todos os direitos reservados.
            </p>
            <p className="flex items-center gap-1">
              Feito com <Heart weight="fill" className="text-[#D500F9]" size={16} /> no Espírito Santo
            </p>
          </div>
          
          <div className="flex flex-col items-center justify-center gap-2 mt-4 pt-4 border-t border-white/5 w-full">
            <p className="text-xs">
              Villaggio Laranjeiras Business - Rua Marataízes, 250 - Valparaíso, Serra - ES, CEP 29165-827. Sala 1016
            </p>
            <p className="text-xs mt-1">
              Desenvolvido por <span className="text-[#D500F9] font-medium">Tomich Tecnologia</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
